/**
 * Level transition overlay (spinner + level name shown while a level loads).
 * Exposed on window because levelManager.js and levelSelector.js call these
 * via the global bridge.
 */

export function showLevelTransition(levelName) {
  const levelTransitionScreen = document.getElementById('level-transition-screen');
  const levelText = document.querySelector('.level-transition-text');
  if (levelText) {
    levelText.textContent = `Loading ${levelName}...`;
  }
  if (levelTransitionScreen) {
    levelTransitionScreen.style.display = 'flex';
    // Force reflow
    levelTransitionScreen.offsetHeight;
    levelTransitionScreen.style.opacity = '1';
  }
}

export function hideLevelTransition() {
  const levelTransitionScreen = document.getElementById('level-transition-screen');
  if (levelTransitionScreen) {
    levelTransitionScreen.style.opacity = '0';
    setTimeout(() => {
      levelTransitionScreen.style.display = 'none';
    }, 300); // Match transition duration
  }
}

window.showLevelTransition = showLevelTransition;
window.hideLevelTransition = hideLevelTransition;
